export default defineNuxtRouteMiddleware(() => {
  const { $userpilot } = useNuxtApp()
  $userpilot?.reload()
})
